import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "./ui/dialog";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";

const STORAGE_KEY = "aurora_welcome_seen_v2";

export default function WelcomeModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const doctorName = (user?.nombre || "").trim() || "médico";

  useEffect(() => {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) {
      const timer = setTimeout(() => setOpen(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setOpen(false);
  };

  const handleStart = () => {
    handleClose();
    navigate("/pacientes");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleClose(); }}>
      <DialogContent className="max-w-lg rounded-2xl p-0 overflow-hidden">

        <div className="bg-sky-600 px-6 py-5">
          <img
            src="/assets/logo/logo-wordmark.png"
            alt="Aurora Geriátrica"
            className="h-7 w-auto object-contain mb-3 brightness-0 invert"
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <h2 className="text-xl font-bold text-white leading-snug">
            Bienvenido a Aurora Geriátrica, Dr. {doctorName}
          </h2>
          <p className="text-sky-100 text-sm mt-1">
            En pocos minutos puedes crear un paciente y registrar tu primera consulta geriátrica
          </p>
        </div>

        <div className="px-6 py-5">
          <ol className="space-y-2 mb-6 text-sm text-slate-700 list-none">
            <li>1. Crea tu primer paciente</li>
            <li>2. Inicia una consulta geriátrica</li>
            <li>3. Genera el informe PDF</li>
          </ol>

          <Button
            className="w-full h-11 rounded-xl bg-sky-600 text-white font-semibold hover:bg-sky-700"
            onClick={handleStart}
          >
            Empezar ahora → Crear mi primer paciente
          </Button>
        </div>

      </DialogContent>
    </Dialog>
  );
}
